export const formatName = (name: string) => {
	return name.charAt(0).toUpperCase() + name.slice(1)
}
